import type { OutlineItem } from './toOutline';

type GetOutline = () => OutlineItem[];

declare global {
  interface Window {
    ardoqRelationshipsViewOutlines?: () => Record<string, OutlineItem[]>;
  }
}

const getOutlineByViewInstanceId = new Map<string, GetOutline>();

const readOutlines = (): Record<string, OutlineItem[]> =>
  Object.fromEntries(
    [...getOutlineByViewInstanceId].map(([viewInstanceId, getOutline]) => [
      viewInstanceId,
      getOutline(),
    ])
  );

/**
 * Lets e2e tests read what each mounted Relationships view draws, through
 * `window.ardoqRelationshipsViewOutlines()`. The outline is only worked out
 * when a test asks for it.
 */
export const registerOutline = (
  viewInstanceId: string,
  getOutline: GetOutline
): VoidFunction => {
  getOutlineByViewInstanceId.set(viewInstanceId, getOutline);
  window.ardoqRelationshipsViewOutlines = readOutlines;
  return () => {
    getOutlineByViewInstanceId.delete(viewInstanceId);
  };
};
